export function personalizationHeroBanner() {
    const dle = JSON.parse(localStorage.getItem("tealium_va_oportun_main") || "{}");

    if (!document.querySelector('body')) return;

    const allHeroSections = document.querySelectorAll('.Hero');

    // Exit the script if no .Hero elements are found
    if (allHeroSections.length === 0) {
        return;
    }

    // Handle badges and properties
    if (dle.badges?.[30630] || dle.badges?.[42391]) {
        // Show  hero by removing control hero
        if (allHeroSections.length > 1) {
            allHeroSections.forEach((currentHero) => {
                if ((currentHero.classList.contains('Hero') && currentHero.classList.contains('CC')) || 
                    (currentHero.classList.contains('Hero') && currentHero.classList.contains('Default'))) {
                    currentHero.remove();
                } else {
                    currentHero.style.display = 'block';
                }
            });
        } else {
            allHeroSections[0].style.display = 'block';
        }

        if (dle.badges?.[42391] && document.querySelector('.comming-payment')) {
            document.querySelector('.comming-payment').style.display = 'block';
        }

        if (dle.properties?.[40557]) {
            console.log('there is a name');
            const nameElement = document.querySelector('.ocw-name');
            if (nameElement) {
                nameElement.textContent = dle.properties[40557];
            }
        } else {
            const sayHiElement = document.querySelector('.ocw-say-hi');
            if (sayHiElement) {
                sayHiElement.innerHTML = sayHiElement.dataset.lang === 'en'
                    ? 'Welcome back!'
                    : '¡Qué bueno que regresaste!';
            }
        }
    } else if (dle.badges?.[30632]) {
        // Handle other badge logic
        allHeroSections.forEach((currentHero) => {
            if ((currentHero.classList.contains('Hero') && currentHero.classList.contains('PL')) || 
                (currentHero.classList.contains('Hero') && currentHero.classList.contains('Default'))) {
                currentHero.remove();
            } else {
                currentHero.style.display = 'block';
            }
        });
    } else {
        // Default logic for other cases
        allHeroSections.forEach((currentHero) => {
            if ((currentHero.classList.contains('Hero') && currentHero.classList.contains('CC')) || 
                (currentHero.classList.contains('Hero') && currentHero.classList.contains('PL'))) {
                currentHero.remove();
            } else {
                currentHero.style.display = 'block';
            }
        });
    }
}